import {useCallback} from 'react';
import {useAuthContext, UserInfo} from './context';

interface IUseAuth {
    setToken: (token: string) => void;
    login: (data: any) => void;
    logout: () => void;
    setUser: (user: UserInfo) => void;
    user: UserInfo | undefined;
    isLoggedIn: boolean;
    token: string | undefined;
    isInitialized: boolean;
}

const useAuth: () => IUseAuth = () => {
    const {onLogout, onLogin, setToken, setUser, user: contextUser, isInitialized} = useAuthContext();
    const {isLoggedIn = false, token} = contextUser || {};

    const logout = useCallback(() => {
        onLogout();
    }, [onLogout]);

    const login = useCallback(
        (data: any) => {
            onLogin(data);
        },
        [onLogin]
    );

    return {
        setToken,
        login,
        logout,
        setUser,
        user: contextUser,
        isLoggedIn,
        token,
        isInitialized,
    };
};

export default useAuth;
